import axios from "../http";

class ExpressInquiry {
  getExpressRuleList(warehouseId) {
    const url = `/oa/api/express/carrier/list?warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //承运商快递规则新增快递
  postExpressAddRule(data) {
    const url = `/oa/api/express/carrier/rule/add`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //删除承运商快递规则信息
  postDelExpress(data) {
    const url = `/oa/api/express/carrier/rule/del`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //获取承运商快递规则详情
  getExpressDetail(warehouseId, expressType, expressMethod, logisticCompanyId) {
    const url = `/oa/api/express/carrier/rule?expressType=${expressType}&warehouseId=${warehouseId}&expressMethod=${expressMethod}&logisticCompanyId=${logisticCompanyId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default ExpressInquiry;
